import { type Cover, coverStyle } from '@/entities/appearance';
import { attachmentPreviewUrl } from '@/entities/attachment';

import styles from './CardCover.module.css';

interface Props {
  cover: Cover;
  /** Image variant: `medium` for tiles and the dialog. */
  className?: string;
  testId?: string;
}

/**
 * The card cover: a color, a gradient or an image of one of the card's attachments, cropped
 * with `object-fit: cover` around its focal point. Decorative (the title says what the card is).
 */
export function CardCover({ cover, className, testId = 'card-cover' }: Props) {
  const classes = [styles.cover, className].filter(Boolean).join(' ');
  if (cover.kind === 'image') {
    return (
      <img
        className={classes}
        data-testid={testId}
        src={attachmentPreviewUrl(cover.attachment_id, 'medium')}
        alt=""
        loading="lazy"
        draggable={false}
        style={{ objectPosition: `${cover.position_x * 100}% ${cover.position_y * 100}%` }}
      />
    );
  }
  return <div className={classes} data-testid={testId} style={coverStyle(cover)} aria-hidden />;
}
